<template>
    <v-dialog
        max-width="500px"
        v-model="dialog"
    >
        <template v-slot:activator="{ on }">
            <v-btn
                icon
                v-on="on"
            >
                <v-icon small>
                    fa-filter
                </v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
        <span class="headline">
          Filter Table</span>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-select
                                clearable
                                hide-details
                                :items="assetTypeListSorted"
                                @input="filterPersonAssetListByAssetType"
                                item-text="name"
                                item-value="assetTypeId"
                                label="Filter by Asset Type"
                                multiple
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                clearable
                                :items="assetStatusListSorted"
                                @input="filterPersonAssetListByAssetStatus"
                                item-text="name"
                                item-value="assetStatusId"
                                label="Filter by Status"
                                multiple
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                clearable
                                :items="livePersonnel()"
                                @input="filterPersonAssetListByPersonId"
                                item-text="name"
                                item-value="personId"
                                label="Filter by Person"
                                multiple
                            />
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    @click="close"
                    color="blue darken-1"
                    text
                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {FILTER_PERSON_ASSET_LIST_BY_ASSET_TYPE,FILTER_PERSON_ASSET_LIST_BY_PERSON_ID,FILTER_PERSON_ASSET_LIST_BY_ASSET_STATUS} from "@/store/person_asset/mutations";
    import {mapGetters} from "vuex";
    import {FETCH_ASSET_TYPE_LIST} from "../../../store/asset_type/actions";
    import {FETCH_ASSET_STATUS_LIST} from "../../../store/asset_status/actions";
    import {FETCH_PERSONNEL} from "../../../store/person/actions";
    import {FETCH_CURRENCY_LIST} from "../../../store/currency/actions";

    export default {
        name: "PersonnelTableFilterDialog",

        data: function () {
            return {
                dialog: false,
            };
        },

        computed: {
            ...mapGetters(
                ["assetTypeListSorted", "livePersonnel", "assetStatusListSorted"]
            )
        },

        mounted() {
            this.fetchAssetTypeList();
            this.fetchPersonnelList();
            this.fetchAssetStatusList();
            this.fetchCurrencyList();
        },

        methods: {
            fetchAssetTypeList() {
                this.$store.dispatch(FETCH_ASSET_TYPE_LIST);
            },
            fetchPersonnelList() {
                this.$store.dispatch(FETCH_PERSONNEL);
            },
            fetchAssetStatusList() {
                this.$store.dispatch(FETCH_ASSET_STATUS_LIST);
            },
            fetchCurrencyList() {
                this.$store.dispatch(FETCH_CURRENCY_LIST);
            },
            filterPersonAssetListByAssetType(value) {
                this.$store.commit(FILTER_PERSON_ASSET_LIST_BY_ASSET_TYPE, value);
            },
            filterPersonAssetListByAssetStatus(value) {
                this.$store.commit(FILTER_PERSON_ASSET_LIST_BY_ASSET_STATUS, value);
            },
            filterPersonAssetListByPersonId(value) {
                this.$store.commit(FILTER_PERSON_ASSET_LIST_BY_PERSON_ID, value);
            },
            close() {
                this.dialog = false;
            }
        }
    }
</script>

<style scoped>

</style>
